import { Box, Icon, Link, Typography } from '@mui/material'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import AdxDropzone from '../../../../../components/reusable/AdxDropzone'
import { presignURL } from 'services/api/presign-url'
import { authContext } from 'contexts/AuthContext'
import axios from 'axios'
import {
  postStatutoryReceipt,
  removeStatutoryReceipt,
} from 'services/api/modules/payroll/payroll-history'
import Bugsnag from '@bugsnag/js'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import AdxButton from 'components/custom/AdxButton'

const UploadReceipt = ({ receiptName, data, time_id, hrdf_status = 1 }) => {
  const dropzoneRef = useRef()
  const [isLoading, setIsLoading] = useState(false)
  const [fileUpload, setFileUpload] = useState(data)
  const { auth } = useContext(authContext)
  useEffect(() => {
    setFileUpload(data)
  }, [data])
  const queryClient = useQueryClient()
  const { mutate: mutatePostStatutoryReceipt } = useMutation(
    (value) => postStatutoryReceipt(time_id, value),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('retrieveStatutoryReceipt')
        setErrorMsg('')
      },
      onError: (err) => {
        Bugsnag.notify(err)
        setErrorMsg(err.message)
        setErrorModal(true)
      },
    }
  )
  const { mutate: deleteStatutoryReceipt } = useMutation(
    (value) => removeStatutoryReceipt(time_id, value),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('retrieveStatutoryReceipt')
      },
      onError: (err) => {
        Bugsnag.notify(err)
      },
    }
  )

  const [errorModal, setErrorModal] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')

  const uploadFile = async (item) => {
    setIsLoading(true)
    try {
      if (auth.data.tenant_id === undefined) {
        throw new Error('Internal error. Tenant id is undefined.')
      }

      const results = await presignURL({
        bucket: process.env.REACT_APP_AWS_BUCKET,
        key: `tenant_${auth.data.tenant_id}/${receiptName}/` + item?.name,
      })
      const awsRequest = axios.create()
      delete awsRequest.defaults.headers.common['Authorization']
      await awsRequest.put(results.data.url, item, {
        headers: {
          'Content-Type': item?.type,
        },
      })
      Object.defineProperty(item, 'awsUrl', {
        writable: true,
        value: results?.data?.url?.split('?')[0],
      })
      await mutatePostStatutoryReceipt({
        attachment: item?.name,
        receipt_type:
          receiptName === 'epf_receipts'
            ? 'epf_form_a'
            : receiptName === 'socso_receipts'
            ? 'socso_form_8a'
            : receiptName === 'eis_receipts'
            ? 'eis_lampiran_1'
            : receiptName === 'lhdn_receipts'
            ? 'mtd_cp39'
            : receiptName === 'hrdf_receipts' && 'hrdf_report',
      })
    } catch (e) {
      setErrorMsg(e.message)
      setErrorModal(true)
      Bugsnag.notify(e)
    } finally {
      setIsLoading(false)
    }
  }
  const handleRemoveFile = () => {
    deleteStatutoryReceipt({
      receipt_type:
        receiptName === 'epf_receipts'
          ? 'epf_form_a'
          : receiptName === 'socso_receipts'
          ? 'socso_form_8a'
          : receiptName === 'eis_receipts'
          ? 'eis_lampiran_1'
          : receiptName === 'lhdn_receipts'
          ? 'mtd_cp39'
          : receiptName === 'hrdf_receipts' && 'hrdf_report',
    })
  }
  const handleErrors = (err) => {
    setErrorMsg(err[0].errors[0].message)
  }
  return (
    <Box>
      <Box sx={{ display: 'none' }}>
        <AdxDropzone
          handleFiles={async (item) => {
            await uploadFile(item)
          }}
          fileType={['photo', 'document']}
          ref={dropzoneRef}
          useDropzoneObject={{
            accept: 'image/*, application/pdf, application/zip',
          }}
          setErrFiles={handleErrors}
        />
      </Box>
      {fileUpload === undefined || fileUpload?.url === null ? (
        <Box sx={{ p: 2 }}>
          <AdxButton
            variant={'contained'}
            fullWidth
            size="small"
            onClick={() => dropzoneRef.current.open()}
            disabled={isLoading || hrdf_status === 0}
          >
            {isLoading ? `Uploading...` : 'Choose file'}
          </AdxButton>
          <AdxErrorMessage>{errorMsg}</AdxErrorMessage>
        </Box>
      ) : (
        fileUpload?.url !== null && (
          <Box display="flex" justifyContent="center" width="100%" columnGap={1}>
            <Link target="_blank" href={fileUpload?.url} sx={{ width: '120px' }}>
              <Typography
                color="alternate.main"
                sx={{ textDecoration: 'underline' }}
                noWrap
                align="left"
              >
                {fileUpload?.title}
              </Typography>
            </Link>
            <Icon
              onClick={() => handleRemoveFile()}
              sx={{ color: 'error.main', cursor: 'pointer' }}
            >
              remove_circle
            </Icon>
          </Box>
        )
      )}

      <AdxInfoModal
        open={errorModal}
        handleClose={() => {
          setErrorModal(false)
          setErrorMsg('')
        }}
        muiIcon="error"
        iconColor="error.main"
        title="Error"
        subtitle={errorMsg}
        footerButtons
        firstBtnLabel={'Ok'}
        firstBtnHandle={() => {
          setErrorMsg('')
          setErrorModal(false)
        }}
      ></AdxInfoModal>
    </Box>
  )
}

export default UploadReceipt
